<template>
  <div class="main-con el-main">
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "ConfigDepartment"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/setting/ConfigDepartment.vue